import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserSelectFilterComponent} from './user-select-filter.component';
import {
    UserSelectFilterStandaloneComponent
} from "../user-select-filter-standalone/user-select-filter-standalone.component";

@NgModule({
    imports: [
        CommonModule,
        UserSelectFilterStandaloneComponent
    ],
    declarations: [
        UserSelectFilterComponent
    ],
    exports: [
        UserSelectFilterComponent
    ]
})
export class UserSelectFilterModule {}